import { Container, StyledButton, Title } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import { StyledErrorWrapper } from 'src/features/error-pages/error-pages.styles';
import ImagePath2x from 'src/images/pngs/500@2x.png';
import ImagePath from 'src/images/pngs/500.png';
import styled from 'styled-components';
const StyledMonospaceSpan = styled.span`
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace !important;
`;
const StyledSpanWithMarginTop = styled.span`
  margin-top: 3.4rem;
`;
export const CriticalError = ({
  message,
  nativeLink = false
}: {
  message?: string;
  nativeLink?: boolean;
}) => <Container data-sentry-element="Container" data-sentry-component="CriticalError" data-sentry-source-file="critical-error.tsx">
    <StyledErrorWrapper data-sentry-element="StyledErrorWrapper" data-sentry-source-file="critical-error.tsx">
      <div>
        <Title titleText="Critical Error" subTitleText={<>
              <StyledMonospaceSpan>{message}</StyledMonospaceSpan>
              <StyledSpanWithMarginTop>
                Please contact support mentioning the message above if the problem persists.
              </StyledSpanWithMarginTop>
            </>} isLeftAlign data-sentry-element="Title" data-sentry-source-file="critical-error.tsx" />

        <StyledButton as={nativeLink ? 'a' : Link} {...nativeLink ? {
        href: '/'
      } : {
        to: '/'
      }} color="primary" variant="solid" data-sentry-element="StyledButton" data-sentry-source-file="critical-error.tsx">
          Take me home
        </StyledButton>
      </div>
      <figure>
        <img src={ImagePath} alt="Critical Error" width="784" height="759" srcSet={`${ImagePath2x} 2x`} />
      </figure>
    </StyledErrorWrapper>
  </Container>;